export default __webpack_public_path__ + "static/media/2.5dcea7f7.jpg";